import { useState } from 'react'
import { message } from 'antd'
import dayjs from 'dayjs'
import ledgersService from '../../Services/Reports/LedgersService'
import { LedgerSortEnum } from 'Common/Constants/Enums/Individual/Reports/LedgerSortByEnum'

export default function useLedgersReport() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false) // Prevents double downloads
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [totalCount, setTotalCount] = useState(0)

  const [filters, setFilters] = useState({
    SortBy: LedgerSortEnum.Latest,
    FromDate: null,
    ToDate: null,
    SourceType: null,
    Status: null,
  })

  const fetchReport = async (params) => {
    setLoading(true)
    try {
      const res = await ledgersService.getReport(params)
      setData(res.data.items || [])
      setTotalCount(res.data.totalCount || 0)
    } catch (error) {
      console.error("API Error:", error)
      message.error('Failed to load ledgers')
    } finally {
      setLoading(false)
    }
  }

  const downloadReport = async (params) => {
    if (isDownloading) return;
    setIsDownloading(true);
    message.loading({ content: 'Generating PDF...', key: 'dl' });

    try {
      const res = await ledgersService.downloadReport(params);

      if (!res.data || res.data.size === 0) throw new Error('Empty response');

      const dateStr = dayjs().format('MMM-DD-YYYY');
      const filename = `CoreIQPro-Payment-Ledger-Report-${dateStr}.pdf`;

      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 500);

      message.success({ content: 'PDF downloaded', key: 'dl' });
    } catch (error) {
      message.error({ content: 'Download failed', key: 'dl' });
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    data, loading, isDownloading, pageNumber, pageSize, totalCount,
    filters, setFilters, setPageNumber, setPageSize, fetchReport, downloadReport,
  }
}